<template>
  <div class="container-fluid" style="height: 100%;">
<!--    <div class="row" style=" z-index: 1; ">-->
<!--      <div class="col-sm-12" id="signup-form" style="height: 100%;display: flex;align-items: center;justify-content: space-evenly;flex-direction: column;">-->
        <simplified-registration :title="title" :buttonLogin="true"></simplified-registration>
        <div class="row m-b m-t-xs">
          <div class="col-md-12 text-center" style="background-color: #ffffff9e; z-index: 500;">
            <strong><a href="https://www.idexlab.com" target="_blank"> IDEXLAB</a></strong><br/> {{year}} Copyright
            Idexlab
          </div>
<!--        </div>-->
<!--      </div>-->
    </div>
  </div>
</template>
<style>
@media (min-width: 990px) {
  .left-col-cover {
    background: url('https://www.idexlab.com/openisme/wp-content/uploads/2020/11/4-5-sans-texte.png') 0px 0px no-repeat;
    -webkit-background-size: cover;
    background-size: cover;
    height: 100%;
  }

  #signup-form {
    overflow: auto;
  }
}

#signup-form .register-container {
  padding-top: inherit;
}

#signup-form .register-container .hpanel {
  margin-bottom: 10px;
}

.hpanel .panel-body {
  border: 1px solid #eaeaea;
}
</style>
<script>

import SimplifiedRegistration from '../../components/register/SimplifiedRegistration'
import RegisterLeftBox from '../../components/register/RegisterLeftBox'

export default {
  components: {
    SimplifiedRegistration, RegisterLeftBox
  },
  name: 'Register',
  beforeMount () {
    let plan = this.$route.query.plan

    let redirect = this.$auth.redirect()
    if (redirect !== null && redirect.from.name !== 'Login' && redirect.from.name !== 'Register') {
      localStorage.setItem('redirect', redirect.from.fullPath)
    }

    if (typeof plan === 'undefined') {
      localStorage.removeItem('register_plan')
      localStorage.removeItem('register_interval')
    } else {
      let interval = this.$route.query.interval
      localStorage.setItem('register_plan', plan)
      localStorage.setItem('register_interval', interval)
    }

    let goal = (this.$route.query.goal) ? decodeURI(this.$route.query.goal) : this.goal

    if (goal === 'topics') {
      this.title = '15 Days Free Trial'
    } else {
      this.title = (!plan || plan === 'basic' || plan === 'expert') ? 'Free Sign Up' : 'Sign Up'
    }
  },
  beforeDestroy () {
    this.$salesMachine.clearUser()
  },
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/register/Register.vue